export enum GanttType {
  ProjectPhaseBar = 'PROJECT_PHASE',
  TaskBar = 'TASK',
  MilestoneBar = 'MILESTONE',
  Sprint = 'SPRINT',
  Subtask = 'SUBTASK',
  AddNewTask = 'ADD_NEW_TASK',
}

export const getGanttPhaseId = (id: number): string =>
  `${GanttType.ProjectPhaseBar}-${id}`;

export const getGanttTaskId = (id: number): string =>
  `${GanttType.TaskBar}-${id}`;

export const getGanttSprintId = (id: number): string =>
  `${GanttType.Sprint}-${id}`;
